import React, { useEffect, useState } from "react";
import { DatePicker } from "rsuite";
import Select from "react-select";

import PageTitle from "../../layouts/PageTitle";
import CustomClearIndicator from "../plugins/Select2/MultiSelect";
import { getDropRolesListApi, getRolesApi } from "../../../services/apis/RolesApi";
import { getZonesApi } from "../../../services/apis/ZoneApi";
import {
  editEmployeeApi,
  employeeCreateApi,
  employeeResetPasswordApi,
  GetEditEmployeeDataApi,
} from "../../../services/apis/EmployeeApi";
import uplodIcon from "../../../assets/images/upload-icon.png";
import PhoneInput from "react-phone-input-2";
import { Toaster } from "../../components/Toaster/Toster";
import { ToastContainer } from "react-toastify";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import apis from "../../../services/apis";
import { useSelector } from "react-redux";
import { CreatelogActivityApi } from "../../../services/apis/IpAddress";
import Swal from "sweetalert2";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from 'react-device-detect';

const EditEmployee = () => {
  const navigate = useNavigate();
  const [changeText, setChangeText] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [logo, setLogo] = useState(null);
  const [cover, setCover] = useState(null);
  const [selectedRoleOption, setSelectedRoleOption] = useState(null);
  const [selectedZoneOption, setSelectedZoneOption] = useState(null);
  const [showPasswordSection, setShowPasswordSection] = useState(null);
  const [imageChanged, setImageChanged] = useState(false);
  const informationIp = useSelector(
    (data) => data?.ipAddressReducers?.ipAddressData
  );
  const user = useSelector((data) => data?.userReducers?.user);
  const [roles, setRoles] = useState();

  const id = useParams()?.id;
  // const [zones, setZones] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    profileImage: "",
  });

  const [SecurityForm, setSecurityForm] = useState({
    user_id: "",
    password: "",
    confirm_password: "",
  });
  let errorsObj = { email: "", mobile: "", firstName: "", lastName: "" };
  const [errors, setErrors] = useState(errorsObj);

  let errorsSecurityObj = { password: "", confirm_password: "" };
  const [securityErrors, setSecurityErrors] = useState(errorsSecurityObj);

  const deviceType = {
    type: isMobile ? "Mobile" : isTablet ? "Tablet" : isDesktop ? "Desktop" : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other"
  };

  const fetchEmployeeData = async (rolesData) => {
    try {
      const res = await GetEditEmployeeDataApi(id);
      const resData = res?.data?.data;
      //  console.log("resssData",resData)
      const updatedFormData = {
        ...resData, // Keep other fields intact
        mobile: resData?.mobile ? `+${resData?.mobile.toString()}` : "", // Ensure the phone number starts with `+` and is a string
      };
      setLogo(resData?.profileImage);
      setFormData(updatedFormData);
      if (rolesData) {
        const currentRole = rolesData?.find(
          (role) => role?.value == resData?.role
        );
        if (currentRole) {
          setSelectedRoleOption(currentRole);
        }
      }
    } catch (err) {
      console.log("errr", err);
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await getDropRolesListApi();
      // Mapping roles data for dropdown format
      const dropdownRoles = res?.data?.roles?.map((role) => ({
        value: role._id,
        label: role.name,
      }));
      // Now set the dropdown formatted data
      setRoles(dropdownRoles);
      fetchEmployeeData(dropdownRoles);
    } catch (error) {
      //error goes here
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  // Handle the logo image change
  const handleLogoChange = (e) => {
    setImageChanged(true);
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLogo(reader.result);
      };
      reader.readAsDataURL(file);
      setFormData({
        ...formData,
        profileImage: file,
      });
      setErrors({
        ...errors,
        profileImage: null,
      });
    }
  };

  // Handle image delete
  const handleDeleteImage = () => {
    setLogo(null); // Clear the image without reopening the file selector
  };

  // Handle the cover image change
  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setCover(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Validation logic for multiple fields
  const validateFields = () => {
    const errorObj = {
      email: "",
      password: "",
      confirm_password: "",
      mobile: "",
      firstName: "",
      lastName: "",
    };
    let isError = false;

    // Email validation
    if (!formData.email) {
      errorObj.email = "Email is required";
      isError = true;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errorObj.email = "Invalid email format";
      isError = true;
    }

    // Phone validation
    if (!formData.mobile) {
      errorObj.mobile = "Mobile number is required";
      isError = true;
    } else if (!/^\+?\d{2}\d{10}$/.test(formData.mobile)) {
      errorObj.mobile = "Mobile number must start with country code (+XX) followed by 10 digits";
      isError = true;
    }

    // Firstname validation
    if (!formData.firstName) {
      errorObj.firstName = "First name is required";
      isError = true;
    }

    // Lastname validation
    if (!formData.lastName) {
      errorObj.lastName = "Last name is required";
      isError = true;
    }

    if (!selectedRoleOption) {
      errorObj.role = 'Role is required';
      isError = true;
  }

    setErrors(errorObj); // Set the validation errors
    return isError; // Return if there's any error
  };

  // const handleInputChange = (e) => {
  //     const { name, value } = e.target;
  //     setFormData((prevState) => ({
  //         ...prevState,
  //         [name]: value,
  //     }));
  // };

  const handleInputChange = (e, field) => {
    const { name, value } = e.target;
    // Update form data
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Reset specific field error when the user starts typing
    if (field === "email") {
      // Custom validation for email field
      if (errors.email) {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      }
    } else if (field === "password") {
      // Custom validation for password field
      if (errors.password) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    } else if (field === "firstName") {
      // Custom validation for firstname field
      if (errors.firstName) {
        setErrors((prevErrors) => ({ ...prevErrors, firstName: "" }));
      }
    } else if (field === "lastname") {
      // Custom validation for lastname field
      if (errors.lastName) {
        setErrors((prevErrors) => ({ ...prevErrors, lastName: "" }));
      }
    }
  };

  const loggedActivity = async () => {
    const data = {
      id: user?._id,
      ipAddress: informationIp?.query,
      lat: informationIp?.lat,
      long: informationIp?.lon,
      logType: "employeeedit",
      deviceType: JSON.stringify(deviceType),
      city: informationIp?.city,
      countryCode: informationIp?.countryCode,
      regionCode: informationIp?.region,
    };
    try {
      await CreatelogActivityApi(data);
    } catch (err) {
      console.log(err);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateFields()) {
      return;
    }
    const employeeData = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobile: formData.mobile,
      email: formData.email,
      // role_id: selectedRoleOption?.value,
      role: selectedRoleOption?.value,
      profileImage: formData?.profileImage,
    };
    try {
      const res = await editEmployeeApi(id, employeeData);
      // console.log("response is here", res);
      if (res?.data?.success) {
        Toaster.success(res?.data?.message);
         Swal.fire({
           icon: "success",
           title: "Employee Updated Successful",
           text: res?.data?.message
         });
        setFormData({
          firstName: "",
          lastName: "",
          mobile: "",
          email: "",
        });
        setLogo(null);
        setSelectedRoleOption(null);
        loggedActivity();
      }
      navigate("/employee/list");
      // Add your form submission logic here, e.g., making an API call with employeeData.
      // console.log('Form Submitted:', employeeData);
    } catch (err) {
      // console.log("e Errr",err?.response?.data?.message)
      Toaster.error(err?.response?.data?.message);
    }
  };

  const handleDeleteLogo = () => {
    setLogo(null);
    setFormData({
      ...formData,
      profileImage: "",
    });
  };

  // Inline styles
  const styles = {
    container: {
      border: "2px dashed #ccc",
      borderRadius: "8px",
      width: "150px", // Logo size
      height: "150px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "#f9f9f9",
      position: "relative",
      textAlign: "center",
      overflow: "hidden",
    },
    coverContainer: {
      border: "2px dashed #ccc",
      borderRadius: "8px",
      width: "300px", // Cover size (2:1 ratio)
      height: "150px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "#f9f9f9",
      position: "relative",
      textAlign: "center",
      overflow: "hidden",
    },
    placeholder: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      textAlign: "center",
    },
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "8px",
    },
    hover: {
      borderColor: "#007bff",
      backgroundColor: "#e9f4ff",
    },
    uploadIcon: {
      color: "#888",
      fontSize: "16px",
      fontWeight: "bold",
    },
    deleteIcon: {
      position: "absolute",
      top: "0px",
      right: "0px",
      backgroundColor: "#FF6D6D",
      color: "white",
      borderRadius: "100%",
      padding: "5px 10px",
      cursor: "pointer",
      zIndex: 2,
      fontSize: "10px",
      fontWeight: "bold",
    },
  };

  const handlePhoneNoChange = (value, country) => {
    const phoneNum = value?.slice(2);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    setFormData({
      ...formData,
      mobile: phone,
    });
  };

  const handleSecurityInputChange = (e) => {
    const { name, value } = e.target;
    // Update form data
    setSecurityForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const validateSecurityFields = () => {
    const errorObj = {
      password: "",
      confirm_password: "",
    };
    let isError = false;
    // Password validation
    if (!SecurityForm.password) {
      errorObj.password = "Password is required";
      isError = true;
    } else if (SecurityForm.password.length < 8) {
      errorObj.password = "Password must be at least 8 characters";
      isError = true;
    }

    if (!SecurityForm.confirm_password) {
      errorObj.confirm_password = "Confirm password is required";
      isError = true;
    } else if (SecurityForm.confirm_password !== SecurityForm.password) {
      errorObj.confirm_password = "Passwords do not match";
      isError = true;
    }

    setSecurityErrors(errorObj); // Set the validation errors
    return isError;
  };

  const handlePasswordSubmit = async () => {
    if (validateSecurityFields()) {
      return;
    }
    const fData = {
      user_id: id,
      password: SecurityForm?.password,
      confirm_password: SecurityForm?.confirm_password,
    };
    try {
      const res = await employeeResetPasswordApi(fData);
      if (res?.data?.success) {
        Toaster.success(res?.data?.message);
        setSecurityForm({
          password: "",
          confirm_password: "",
        });
        setShowPasswordSection(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // employResetPasswordApi
  return (
    <>
      <ToastContainer />
      <PageTitle activeMenu={"Edit Employee"} motherMenu={"Employees"} />
      <div className="row">
        {/* SECTION 1st Genaral Information */}
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Genaral Information</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12 col-md-8  row">
                  <div className="col-sm-6">
                    <label className="col-form-label">First Name<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Ex: John"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                    />
                    {errors.firstName && (
                      <div className="text-danger fs-12">
                        {errors.firstName}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6 mt-2 mt-sm-0">
                    <label className="col-form-label">Last Name<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      placeholder="Ex: Doe"
                    />
                    {errors.lastName && (
                      <div className="text-danger fs-12">{errors.lastName}</div>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <label className="col-form-label">Role<span className="text-danger">*</span></label>
                    <Select
                      defaultValue={selectedRoleOption}
                      onChange={setSelectedRoleOption}
                      options={roles}
                      value={selectedRoleOption}
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                     {errors.role && <div className="text-danger fs-12">{errors.role}</div>}
                  </div>

                  <div className="col-sm-6 mt-2 mt-sm-0">
                    <label className="col-form-label">Mobile<span className="text-danger">*</span></label>
                    <PhoneInput
                      className=""
                      inputClass=""
                      country={"in"}
                      value={formData?.mobile}
                      onChange={handlePhoneNoChange}
                    />
                    {errors.mobile && (
                      <div className="text-danger fs-12">{errors.mobile}</div>
                    )}
                  </div>
                </div>

                <div className="col-sm-6 col-md-4 flex justify-center items-center">
                  <div
                    className="col-sm-12"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }} >
                    <label className="col-form-label">Employee Image</label>
                    <div style={styles.container}>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleLogoChange}
                        style={{ display: "none" }}
                        id="logoUpload"
                      />
                      {logo ? (
                        <>
                          {!imageChanged ? (
                            <>
                              {/* Simple 'X' button as the delete icon */}
                              <div
                                className="deleteIcon"
                                onClick={handleDeleteLogo}>
                                ⛌
                              </div>
                              <img
                                className="img"
                                src={`${apis?.baseurl.Baseimageurl}${logo}`}
                                alt="Logo"
                              />
                            </>
                          ) : (
                            <>
                              <div
                                className="deleteIcon"
                                onClick={handleDeleteLogo}
                              >
                                {" "}
                                ⛌{" "}
                              </div>
                              <img className="img" src={logo} alt="Logo" />
                            </>
                          )}
                        </>
                      ) : (
                        <label htmlFor="logoUpload" className="imgPlaceholder">
                          <div className="flex flex-col cursor-pointer imgUploadIcon">
                            <img
                              width="30"
                              src={uplodIcon}
                              alt="Upload Icon"
                            ></img>
                            <p>Upload Image</p>
                          </div>
                        </label>
                      )}
                    </div>
                    <p className="mt-2">
                      Image format - jpg png jpeg gif
                      <br />
                      Image Size - maximum size 2 MB
                      <br />
                      Image Ratio - 1:1
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 2nd Account Info*/}
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Account Info</h4>
              <button
                className="change-password-btn"
                onClick={() => setShowPasswordSection(true)}>
                Change Password ?
              </button>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4">
                  <label className="col-form-label">Email<span className="text-danger">*</span></label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Ex: John@company.com"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  {errors.email && (
                    <div className="text-danger fs-12">{errors.email}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showPasswordSection && (
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Security<span className="text-danger">*</span></h4>
                <button
                  className="change-password-btn"
                  onClick={() => setShowPasswordSection(false)}
                >
                  <IoClose size={26} />
                </button>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-4 mt-2 mt-sm-0">
                    <label className="col-form-label">Password<span className="text-danger">*</span></label>
                    <div className="input-group pass-group">
                      <input
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        className="form-control pass-input"
                        name="password"
                        value={SecurityForm?.password}
                        onChange={handleSecurityInputChange}
                      />
                      <span
                        className={`input-group-text pass-handle ${
                          showPassword ? "active" : ""
                        }`}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className="fa fa-eye-slash" />
                        <i className="fa fa-eye" />
                      </span>
                    </div>
                    {securityErrors?.password && (
                      <div className="text-danger fs-12">
                        {securityErrors?.password}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-4 mt-2 mt-sm-0">
                    <label className="col-form-label">Confirm Password<span className="text-danger">*</span></label>
                    <div className="input-group pass-group">
                      <input
                        placeholder="Confirm Password"
                        type={changeText ? "text" : "password"}
                        className="form-control pass-input"
                        name="confirm_password"
                        value={SecurityForm?.confirm_password}
                        onChange={handleSecurityInputChange}
                      />

                      <span
                        className={`input-group-text pass-handle ${
                          changeText ? "active" : ""
                        }`}
                        onClick={() => setChangeText(!changeText)}
                      >
                        <i className="fa fa-eye-slash" />
                        <i className="fa fa-eye" />
                      </span>
                    </div>
                    {securityErrors?.confirm_password && (
                      <div className="text-danger fs-12">
                        {securityErrors?.confirm_password}
                      </div>
                    )}
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button
                    type="button"
                    onClick={handlePasswordSubmit}
                    className="btn btn-primary rounded-sm">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Section Submit button */}
        <div className="text-end">
          <button
            type="submit"
            onClick={handleSubmit}
            className="btn btn-primary rounded-sm">
            Save Information
          </button>
        </div>
      </div>
    </>
  );
};

export default EditEmployee;
